import React, { useState } from "react";
import DragAndDropUpload from "components/atoms/DragAndDropUpload/DragAndDropUpload";
import AzureBlobDownloader from "../AzureDownload(notused)/AzureDownload";
import BulkLead from "../BulkLead/BulkLead";
import { Empty } from "components/atoms/Empty";
import Button from "components/atoms/Button/Button";
import { useDispatch } from "react-redux";
import { handleToggleBulkSearch } from "store/slices/ui.slice";

const templateLink = "https://middlewarexdevxstorage.blob.core.windows.net/dev/export_a88e4c6b-4570-4152-be08-f2defc8e97d0.csv";

const BulkSearch: React.FC = () => {
  const dispatch = useDispatch()
  const [listName, setListName] = useState<string>("");
  const [uploadState, setUploadState] = useState<boolean>(false);
  const [CSVObject, setCSVObject] = useState([]);
  const [uploadFiles, setUploadFiles] = useState(null);
  const handleUpload = ({ files, parsed, parsedCSV }: any) => {
    setUploadState(parsed);
    setCSVObject(parsedCSV);
    setListName(files.name)
    setUploadFiles(files);
  };

  return (
    <div className={`w-full max-w-[400px] justify-center border-l border-gray-700 items-center overflow-hidden flex flex-col h-full border-r p-4 text-center`}>
      {!uploadState && <div>
        <Empty title="Bulk Search"
          message={
            <div className="flex flex-col justify-center items-center">
              <p className="text-gray-400 text-base mb-2 mt-4">
                Please upload your file in <strong>CSV Format</strong>
              </p>
              <AzureBlobDownloader blobName={`${templateLink}`}>Download a template</AzureBlobDownloader>
            </div>
          } />
      </div>}

      {!uploadState ? (
        <div className='p-4 flex flex-col gap-4'>
          <DragAndDropUpload handleUpload={handleUpload} />
          <div className="md:hidden">
            <AzureBlobDownloader blobName={`${templateLink}`}>Download a template</AzureBlobDownloader>
          </div>
        </div>
      ) : (
        <BulkLead
          file={uploadFiles}
          listName={listName}
          CSVObject={CSVObject}
          uploadState={setUploadState}
        />
      )}
      <Button type="download" action="button" onClick={() => dispatch(handleToggleBulkSearch())} iconName="close" size="sm" > cancel </Button>
    </div>
  );
};

export default BulkSearch;
